import Footer from "../components/Footer";
import Popular from "../components/Popular";
import ProductList from "../components/ProductList";
import SearchForm from "../components/SearchForm";

function Home() {
  return (
    <div>
      <SearchForm />
      <ProductList />
      <Popular />
      <Footer />
    </div>
  );
}

export default Home;
